import { Spine } from 'pixi-spine';
import { Howl } from 'howler';
import { SettingsResponse } from '../store/reducers/settings/types';
import { LeaguesUnion, ProfileResponseT } from '../types';
import { SoundsT } from './helperTypes';

export function numberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function getSecondsBetweenDates(startDate: Date, endDate: Date) {
  const diff = endDate.getTime() - startDate.getTime();
  return Math.round(diff / 1000);
}

export const getMinutesFromSeconds = (seconds: number) => Math.floor(seconds / 60);
export const formatNumbers = (number: number, digits = 2, useNotation = true) => Intl.NumberFormat('en-US', {
  notation: useNotation ? 'compact' : undefined,
  maximumFractionDigits: digits,
}).format(number);

export const getNextLeagueCoins = (leagues: SettingsResponse['leagues'], userLeague: ProfileResponseT['league']['name']) => {
  const currentLeagueIndex = leagues?.findIndex((league) => league?.name === userLeague) || 0;
  const nextLeagueIndex: number = currentLeagueIndex === (leagues.length + 1) ? leagues.length : currentLeagueIndex + 1;
  return leagues[nextLeagueIndex]?.from || 0;
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}.${month}.${year}, ${hours}:${minutes}`;
};

export const calculateScale = (animation: Spine | SpineGameObject, targetWidth: number, targetHeight: number) => {
  const originalWidth = animation.width;
  const originalHeight = animation.height;
  const scaleX = targetWidth / originalWidth;
  const scaleY = targetHeight / originalHeight;
  return Math.min(scaleX, scaleY);
};

export function randomIntFromInterval(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function toggleMute(isEnable: boolean): void {
  Howler.volume(isEnable ? 1 : 0);
}

export const getStarBg = (league: LeaguesUnion) => {
  switch (league) {
    case 'Bronze':
      return 'before:bg-leaderboardBronzeBg';
    case 'Silver':
      return 'before:bg-leaderboardSilverBg';
    case 'Gold':
      return 'before:bg-leaderboardGoldBg';
    case 'Platinum':
      return 'before:bg-leaderboardPlatinumBg';
    case 'Diamond':
      return 'before:bg-leaderboardDiamondBg';
    case 'Challenger':
      return 'before:bg-leaderboardChallengerBg';
    case 'Legendary':
      return 'before:bg-leaderboardLegendaryBg';
    case 'Master':
      return 'before:bg-leaderboardMasterBg';
    default:
      return 'before:bg-leaderboardBronzeBg';
  }
};

export const stopSounds = (sounds: SoundsT) => {
  Object.values(sounds).forEach((sound) => {
    sound.stop();
    sound.off('end');
  });
};

export const createSound = (src: string) => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return new Howl({ src: [src], html5: isSafari });
};
